<template>
  <v-app class="contenedor">
    <div class="dashboard-admin">
      <v-row class="graph">
        <v-col cols="6" xs="12" sm="12" lg="6" md="6">
          <v-card hover elevation-2 color="grey lighten-4">
            <v-card-title
            >Indices Fiat / IPSA / Dólar CCL / Dólar Oficial </v-card-title
            >
            <ChartDolarAcaraComponent></ChartDolarAcaraComponent>
          </v-card>
        </v-col>
        <v-col cols="6" xs="12" sm="12" lg="6" md="6">
          <v-card hover elevation-2 color="grey lighten-4">
            <v-card-title
            >Indices Fiat / IPSA / Dólar CCL / Dólar Oficial por Fechas</v-card-title
            >
            <ChartDolarAcaraFechasComponent></ChartDolarAcaraFechasComponent>
          </v-card>
        </v-col>
      </v-row>
      <v-row justfy="center" class="evolucion">
        <v-col cols="12" xs="12" sm="12" lg="3" md="3">
          <GridControlComponent></GridControlComponent>
        </v-col>
        <v-col cols="12" xs="12" sm="12" lg="9" md="9">
          <v-row>
            <v-col cols="12" xs="12" sm="12" lg="12" md="12">
              <GridCarteraGral></GridCarteraGral>
            </v-col>
          </v-row>

          <v-row  class="performance">
            <v-col cols="12" xs="12" sm="12" lg="12" md="12">
              <v-card hover elevation-2 color="grey lighten-4">
                <v-card-title>Reporte Performance</v-card-title>
                <GridPerformanceComponent></GridPerformanceComponent>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!--
      <v-row justfy="center" class="performance">
        <v-col cols="12" xs="12" sm="12" lg="12" md="12">
          <v-card hover elevation-2 color="grey lighten-4">
            <v-card-title>Reporte Performance</v-card-title>
            <GridPerformanceComponent></GridPerformanceComponent>
          </v-card>
        </v-col>
      </v-row>
      -->
    </div>
  </v-app>
</template>

<script>
import GridControlComponent from '@/components/propios/GridControlComponent'
import GridPerformanceComponent from '@/components/propios/GridPerformanceComponent'
import ChartDolarAcaraComponent from '@/components/propios/ChartDolarAcaraComponent'
import ChartDolarAcaraFechasComponent from '@/components/propios/ChartDolarAcaraFechasComponent'
import GridCarteraGral from '@/components/propios/GridCarteraGral'
// import BaseMaterialStatsCard from "@/components/base/MaterialCard";

export default {
  name: 'dashboardadmin',
  data () {
    return {
      sizeicon: 64,
    }
  },
  components: {
    GridControlComponent,
    GridPerformanceComponent,
    ChartDolarAcaraComponent,
    ChartDolarAcaraFechasComponent,
    GridCarteraGral,
  },
}
</script>

<style lang="scss">
.contenedor {
  width: 100%;
  //background-color: #eeeeee;
}

.performance {
  padding-top: 260px;
}

.row-equal {
  margin-top: 10px;
  padding-bottom: 5px;
}

.rounded-card {
  border-radius: 100px;
}

.row-equal .flex {
  .va-card {
    height: 100%;
  }
}

.dashboard-admin {
  padding-bottom: 10px;
}
</style>
